/** Product choices for a batch product change / split: enabled products of the same class (Beer → Beer). */
export interface ProductOption {
  id: number | string;
  name: string;
  class?: string | null;
  enabled?: number | boolean | null;
}

const norm = (v: unknown) => String(v ?? '').trim().toLowerCase();

export function productChoices<T extends ProductOption>(products: T[], current: { productId?: number | string | null; productName?: string | null }): T[] {
  const cur =
    products.find((p) => current.productId != null && String(p.id) === String(current.productId)) ||
    products.find((p) => current.productName && norm(p.name) === norm(current.productName));
  const cls = cur ? norm(cur.class) : null;
  return products
    .filter((p) => p.enabled == null || Number(p.enabled) !== 0)
    .filter((p) => cls == null || norm(p.class) === cls)
    .sort((a, b) => String(a.name).localeCompare(String(b.name)));
}

/** Root of a split family: "RBP080726.3" → "RBP080726". */
export function batchFamilyRoot(batchId: string | number | null | undefined): string {
  return String(batchId ?? '').trim().replace(/\.\d+$/, '');
}

/** Validate a split amount against what's left. */
export function parseSplitVolume(raw: string, left: number | null | undefined): { value?: number; error?: string } {
  const n = Number(String(raw).trim());
  if (!String(raw).trim() || !Number.isFinite(n) || n <= 0) return { error: 'Enter the bbl to split off (a positive number).' };
  const v = Math.round(n * 100) / 100;
  if (left == null) return { error: "Can't tell how much is left, so this batch can't be split." };
  if (v > Number(left) + 0.005) return { error: `Only ${Math.round(Number(left) * 100) / 100} bbl is left; you can't split off ${v} bbl.` };
  return { value: v };
}
